import React, { useCallback, useRef } from 'react'
import { NovaEditor } from '@emerald-works-nova/editor'
import { Controller } from 'react-hook-form'
import { useContentForm } from '../../content-form-context'
import { useSelector } from 'react-redux'
import ContentSlice from '../../../../reducers/content'
import { useStyles } from './style'
import { usePromiseEvent } from '../../../../hooks'
import TinyEditorComponent from '../../../../components/tiny-editor'
import dompurify from 'dompurify'
import { useParams } from 'react-router'

const AVAILABLE_EDITORS = {
  DRAFT_JS: 'draftjs',
  TINYMCE: 'tinymce'
}

const useScormCloudCallbacks = ({ contentId }) => {
  const scormGetImportJobStatus = usePromiseEvent('scormGetImportJobStatus')
  const scormCreateFetchAndImportCourse = usePromiseEvent('scormCreateFetchAndImportCourse')

  const createFetchAndImportCourse = useCallback(async ({
    scormS3Key
  }) => {
    const result = await scormCreateFetchAndImportCourse({
      courseId: contentId,
      scormS3Key
    })

    console.log('Scorm create fetch and import course result', result)
    return result
  }, [scormCreateFetchAndImportCourse, contentId])

  const getImportJobStatus = useCallback(async (importJobId) => {
    const result = await scormGetImportJobStatus({
      importJobId
    })

    console.log('Scorm get import job status result', result)
    return result
  }, [scormGetImportJobStatus])

  return {
    createFetchAndImportCourse,
    getImportJobStatus
  }
}

const Body = () => {
  const { form, isReadOnly } = useContentForm()
  const tinyMceRef = useRef()
  const { locationId } = useParams()
  const content = useSelector(ContentSlice.selectors.selectContent)
  const editor = content?.primaryType?.includes('bespoke') ? AVAILABLE_EDITORS.TINYMCE : AVAILABLE_EDITORS.DRAFT_JS
  const readTime = form.getValues().readTime
  const classes = useStyles({ isTinyMce: editor === AVAILABLE_EDITORS.TINYMCE })
  const deleteTranscript = usePromiseEvent('contentDeleteTranscript')
  const deleteImage = usePromiseEvent('contentDeleteImage')
  const scormCloudCallbacks = useScormCloudCallbacks({ contentId: locationId })

  const searchContent = usePromiseEvent('catalogSearch')

  const handleSearchContent = (search) => {
    return searchContent({
      size: 10,
      filters: {
        search
      }
    })
  }

  const updateReadTime = (newTime) => {
    form.setValue('readTime', newTime)
  }

  const onDeleteTranscript = useCallback(async (transcriptKey) => {
    await deleteTranscript({ s3Key: transcriptKey })
  }, [deleteTranscript])

  const onDeleteImage = useCallback(async (imageKey) => {
    await deleteImage({ s3Key: imageKey })
  }, [deleteImage])

  return (
    <div className={classes.root}>
      <Controller
        name='body'
        control={form.control}
        defaultValue={null}
        render={(
          { field: { onChange, value } }
        ) => {
          if (editor === AVAILABLE_EDITORS.DRAFT_JS) {
            return (
              <NovaEditor
                endUserView={isReadOnly}
                body={value}
                type={content.primaryType[0]}
                onChange={({ data }) => {
                  onChange({
                    type: 'draftjs',
                    data
                  })
                }}
                scormCloudCallbacks={scormCloudCallbacks}
                onDeleteTranscript={onDeleteTranscript}
                onDeleteImage={onDeleteImage}
                handleSearchContent={handleSearchContent}
                readTime={readTime}
                updateReadTime={updateReadTime}
              />
            )
          }

          return (
            <TinyEditorComponent
              value={value?.data?.html}
              name='body'
              ref={tinyMceRef}
              setValue={(name, data) => {
                dompurify.sanitize(data, {
                  USE_PROFILES: {
                    html: true,
                    svg: true,
                    svgFilters: true
                  },
                  ADD_ATTR: ['target'],
                  ADD_TAGS: ['iframe']
                })

                onChange({
                  type: 'tinymce',
                  data: {
                    html: data
                  }
                })
              }}
            />
          )
        }}
      />
    </div>
  )
}

export default Body
